/* Free-gift auto-add — adds the gift product (Wild Rose Face Polish) once the
   cart's non-gift subtotal reaches the threshold, mirroring the automatic
   "spend $X, get Y free" discount that zeroes it. Removes it if the cart drops
   back under. SAFETY: after adding, it verifies the discount actually zeroed the
   gift; if not (mis-config / wrong-currency threshold), it removes it and stops —
   the gift is NEVER left in the cart at a charge. */
(function () {
  var CFG = window.PR_GIFT || {};
  var GIFT = CFG.variant;
  var THRESHOLD = CFG.threshold || 0;
  if (!GIFT || !THRESHOLD) return;

  var busy = false;
  var failedAt = -1; // non-gift subtotal (cents) where the gift added but the discount didn't zero it; skip retrying at/under this level (never charge, no loop), retry once the cart grows past it. Resets on reload.

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function cartJson() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
  }
  function subExcl(cart) {
    var s = 0;
    (cart.items || []).forEach(function (it) { if (it.id !== GIFT && it.variant_id !== GIFT) s += it.final_line_price; });
    return s;
  }
  function findGift(cart) {
    var g = null;
    (cart.items || []).forEach(function (it) { if (it.id === GIFT || it.variant_id === GIFT) g = it; });
    return g;
  }
  function removeGift() { return post('/cart/change.js', { id: String(GIFT), quantity: 0 }); }

  function hardRefresh() {
    return fetch('/cart?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      try {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var cur = document.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var cd = document.querySelector('cart-drawer');
        if (cd) cd.classList.toggle('is-empty', !document.querySelector('.cart-item'));
      } catch (e) {}
    });
  }

  function ensure() {
    if (busy) return;
    busy = true;
    cartJson()
      .then(function (cart) {
        var subEx = subExcl(cart);
        var gift = findGift(cart);
        var qualifies = subEx >= THRESHOLD;

        if (qualifies && !gift && subEx > failedAt) {
          // append via /cart/add.js so the gift lands at the END of the cart — /cart/update.js was prepending it and shifting every line index (broke qty/remove)
          return post('/cart/add.js', { items: [{ id: GIFT, quantity: 1 }] })
            .then(cartJson)
            .then(function (c2) {
              var g2 = findGift(c2);
              if (g2 && g2.final_line_price > 0) {   // discount didn't apply at this level — remember it, remove, never charge
                failedAt = subEx;
                return removeGift().then(hardRefresh);
              }
              failedAt = -1;
              return hardRefresh();
            });
        }
        if (!qualifies && gift) { return removeGift().then(hardRefresh); }
        if (gift && gift.final_line_price > 0) { return removeGift().then(hardRefresh); } // discount fell off
      })
      .then(function () { busy = false; })
      .catch(function () { busy = false; });
  }

  /* ---- the lip hero's own Add handler: delegated at document level so it
     survives every re-injection, and it always opens the slide-drawer instead of
     falling back to a /cart page navigation. ---- */
  function openDrawer(drawer) {
    return fetch('/cart?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      try {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var cur = document.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      } catch (e) {}
      if (drawer && typeof drawer.open === 'function') drawer.open();
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pr-lip-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn._busy) return;
    var wrap = btn.closest('.pr-lip__form') || btn.parentNode;
    var sel = wrap ? wrap.querySelector('[data-pr-lip-select]') : null;
    var id = sel ? parseInt(sel.value, 10) : 0;
    if (!id) return;
    btn._busy = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    var cartDrawer = document.querySelector('cart-drawer');
    var cart = cartDrawer || document.querySelector('cart-notification');
    var payload = { items: [{ id: id, quantity: 1 }] };
    try {
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        payload.sections_url = window.location.pathname;
      }
    } catch (err) {}
    post('/cart/add.js', payload)
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'Could not add to cart.');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pr-lip', cartData: res });
        if (cart) {
          if (cartDrawer) { var di = cartDrawer.querySelector('.drawer__inner'); if (di) di.classList.remove('is-empty'); cartDrawer.classList.remove('is-empty'); }
          if (res.sections && typeof cart.renderContents === 'function') { try { cart.renderContents(res); } catch (e2) { return openDrawer(cartDrawer || cart); } }
          else return openDrawer(cartDrawer || cart);
        } else { window.location = '/cart'; }
      })
      .catch(function (err) { alert(err.message || 'Could not add to cart.'); })
      .then(function () { btn._busy = false; btn.textContent = label; });
  });

  /* ---- hide the lip-balm hero whenever a lip is in the cart; robust to the
     upsell's stale re-injection (and the theme editor, which mis-fetches). ---- */
  var lipInCart = false;
  var lineMap = {};
  function applyHero() {
    var hs = document.querySelectorAll('#CartDrawer .pr-lip');
    for (var i = 0; i < hs.length; i++) hs[i].style.display = lipInCart ? 'none' : '';
  }
  // Re-point each visible line's data-index (+ quantity input id) to its REAL cart line.
  // Auto-added add-ons (Delivery Protection / gift) can sit ahead of the rendered rows,
  // so the server-rendered indices drift and qty/remove hit the wrong line ("line parameter is invalid").
  function applyLineMap() {
    var rows = document.querySelectorAll('#CartDrawer .cart-item');
    for (var r = 0; r < rows.length; r++) {
      var tr = rows[r];
      var vEl = tr.querySelector('[data-quantity-variant-id]') || tr.querySelector('[data-variant-id]');
      var vid = vEl ? (vEl.getAttribute('data-quantity-variant-id') || vEl.getAttribute('data-variant-id')) : null;
      if (!vid) continue;
      var line = lineMap[String(vid)];
      if (!line) continue;
      var idxEls = tr.querySelectorAll('[data-index]');
      for (var i = 0; i < idxEls.length; i++) idxEls[i].setAttribute('data-index', line);
      var qi = tr.querySelector('input.quantity__input');
      if (qi) qi.id = 'Drawer-quantity-' + line;
    }
  }
  function applyBoth() { applyHero(); applyLineMap(); }
  function refresh() {
    cartJson().then(function (cart) {
      lipInCart = (cart.items || []).some(function (it) { return it.handle === 'lip-balm'; });
      lineMap = {};
      (cart.items || []).forEach(function (it, i) { lineMap[String(it.variant_id)] = i + 1; });
      applyBoth();
    }).catch(function () {});
  }
  var refreshHero = refresh;
  (function watchDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) { setTimeout(watchDrawer, 300); return; }
    new MutationObserver(applyBoth).observe(cd, { childList: true, subtree: true });
  })();

  /* Lumin's pub/sub globals are bare-identifier consts (not on window) — guard + retry. */
  var subscribed = false;
  function ready() { try { return typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function'; } catch (e) { return false; } }
  function trySub(n) {
    if (!subscribed && ready()) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(ensure, 140); setTimeout(refreshHero, 220); });
      subscribed = true;
      return;
    }
    if (n > 0) setTimeout(function () { trySub(n - 1); }, 150);
  }
  trySub(40);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ensure(); refreshHero(); });
  else { ensure(); refreshHero(); }
})();
